import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Description, LottiePlayer } from '@repo/ui';
import { useEffect, useState } from 'react';
import { usePreloadedQuery } from 'react-relay';

import { mySectionUserQuery } from '@/__generated__/mySectionUserQuery.graphql';
import { MyUserQueryType } from '@/components/menu/MySection';
import { myUserQuery } from '@/graphql/query/my/my-section';
import { AD_SLOT_RESOURCE_CENTER_URL, SlotTargetType } from '@/lib/constants/ad-slots';
import { useAdSlots } from '@/lib/hooks/use-ad-slots';

export const MenuBottomCardBanner = ({ queryRef }: { queryRef: MyUserQueryType }) => {
  const { bznavRefund } = usePreloadedQuery<mySectionUserQuery>(myUserQuery, queryRef);
  const [isHydrate, setIsHydrate] = useState(false);
  const [corpType, setCorpType] = useState<SlotTargetType | null>(null);

  useEffect(() => {
    setIsHydrate(true);
  }, []);

  useEffect(() => {
    if (!isHydrate) return;
    if (!bznavRefund?.user) return;

    const isPersonalTritx = sessionStorage.getItem('isPersonalTritx') === 'true';
    if (isPersonalTritx) {
      setCorpType('PERSONAL');
    } else if (bznavRefund.user.indis?.length || bznavRefund.user.previousIndis?.length) {
      setCorpType('INDIS');
    } else if (bznavRefund.user.corps?.length) {
      setCorpType('CORPS');
    } else {
      setCorpType('NONE');
    }
  }, [bznavRefund.user, isHydrate]);

  if (!corpType) return null;
  return <CardBanner corpType={corpType} />;
};

const CardBanner = ({ corpType }: { corpType: SlotTargetType }) => {
  const { slots, handleRouteChange, replaceNewLine } = useAdSlots('MY_PAGE_BOTTOM', corpType);
  const { sendClickEvent } = useUserEventLogger();

  const slot = slots?.[0];
  const item = slot?.items?.[0];

  const imageUrl = item?.imagePath ? `${AD_SLOT_RESOURCE_CENTER_URL}/${item?.imagePath}` : '';
  const DescriptionGraphic = () => {
    if (imageUrl.endsWith('json')) {
      return (
        <div className={'w-[88px] h-[88px]'}>
          <LottiePlayer src={imageUrl} loop={true} autoPlay={true} />
        </div>
      );
    }
    if (imageUrl) {
      return <img src={imageUrl} alt={slot?.title ?? ''} width={88} height={88} />;
    }
    return <></>;
  };

  if (!slot?.items?.length) return null;
  return (
    <div className={'bg-gray-50 rounded-5 mb-8 mx-4.5'}>
      <Description
        graphic={<DescriptionGraphic />}
        title={replaceNewLine(item?.displayTitle)}
        description={replaceNewLine(item?.description)}
        className={'whitespace-pre-line'}
        button={
          <BoxButton
            onClick={(e) => {
              /**
               * FIXME
               * type='button' 속성을 사용하면 구UI로 인해 버튼 스타일이 비정상적으로 노출되어
               * type 속성 제거 후(자동으로 submit 타입 설정) 오동작 방지를 위한 preventDefault 처리
               */
              e.preventDefault();
              if (item?.userEvent) {
                sendClickEvent(item.userEvent);
              }
              handleRouteChange(item?.linkUrl ?? '');
            }}
          >
            {item?.buttonText}
          </BoxButton>
        }
      />
    </div>
  );
};
